import { AbstractControl } from '@angular/forms';

export class PasswordValidator {
  public static matchPassword(ac: AbstractControl) {
    const password = ac.get('password');
    const passwordConfirmation = ac.get('confirmPassword');
    const passwordValue = password?.value;
    const passwordConfirmationValue = passwordConfirmation?.value;

    if (passwordValue === passwordConfirmationValue) {
      const errors = passwordConfirmation?.errors;

      if (errors) {
        delete errors['matchPassword'];
        passwordConfirmation?.setErrors(
          Object.keys(errors).length ? errors : null
        );
      }
    } else {
      passwordConfirmation?.setErrors({
        ...passwordConfirmation?.errors,
        matchPassword: true,
      });
    }
    return null;
  }
}
